import Vue from 'vue'

Vue.component('TargetTimeline', () => import('./Timeline.vue'))
Vue.component('TargetMoveForms', () => import('./MoveForms.vue'))
Vue.component('TransferTarget', () => import('./Transfer.vue'))